module.exports = __webpack_public_path__ + "img/face-grin.77c3bda6.svg";